import type { ElementType } from "react"

import { filledColumns } from "@/components/marketplace/discovery/filled-columns"
import { Duotone } from "@/components/marketplace/layout/duotone"
import type { MegaCategory } from "@/components/marketplace/types"
import { ArrowUpRightIcon, Grid, Heading, Text } from "@/components/ui"
import { Link } from "@/i18n/navigation"

export const MegaCategories = ({ items }: { items: MegaCategory[] }) => (
  <div className="@container">
    <Grid cols={2} colsDesktop={filledColumns(items.length)} gap="300" className="@3xl:gap-500">
      {items.map((item, index) => {
        const Tile: ElementType = item.href ? Link : "div"
        return (
          <Tile
            key={item.id}
            {...(item.href ? { href: item.href } : {})}
            data-nelo-serve={item.serveId}
            style={{ animationDelay: `${Math.min(index, 8) * 70}ms` }}
            className="press rounded-12x focus-visible:ring-palette-bar motion-safe:animate-rise-in group relative aspect-square overflow-hidden focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none"
          >
            <Duotone
              src={item.image}
              alt={item.label}
              sizes="(max-width: 768px) 50vw, 320px"
              className="duration-moderate ease-productive absolute inset-0 transition-transform motion-safe:group-hover:scale-105"
            />
            <span className="bg-scrim-photo absolute inset-0" aria-hidden />
            <span className="text-fg-inverted duration-quick ease-productive absolute top-300 right-300 opacity-0 transition-opacity group-hover:opacity-100">
              <ArrowUpRightIcon size={18} />
            </span>
            <div className="absolute inset-0 flex flex-col justify-end p-400 @3xl:p-600">
              <Heading as="div" variant="sm" family="display" tone="inverted" balance className="text-shadow-scrim @3xl:text-heading-lg font-extrabold tracking-tight">
                {item.label}
              </Heading>
              {item.count && (
                <Text as="div" variant="eyebrow" tone="inverted" className="mt-100 opacity-85">
                  {item.count}
                </Text>
              )}
            </div>
          </Tile>
        )
      })}
    </Grid>
  </div>
)
